<script>
    import { createEventDispatcher } from "svelte";
    import Button from "../ui/Button.svelte";
    import AddOffer from "./AddOffer.svelte";
    import OfferItem from "./OfferItem.svelte";
    import OffersListHeader from "./OffersListHeader.svelte";
    import Credits from "./Credits.svelte";
    
    export let offers;
    export let credits;
    export let dealSettings;

    $: offers_by_month = sortOffers(offers);
    $: totalReservedExtra = Object.values(credits.months).reduce((sum, month) => {
        return sum + month.reserved_extra;
    }, 0);

    function sortOffers(offers) {
        const _offers_by_month = {
            0: [],
            1: [],
            2: [],
            3: [],
            4: [],
            5: [],
            6: [],
            7: [],
            8: [],
            9: [],
            10: [],
            11: []
        };
        offers.forEach(offer => {
            if (offer.show_from) {
                const show_from = offer.show_from.toDate();
                const month = show_from.getMonth();
                _offers_by_month[month].push(offer);
            }
        });
        return _offers_by_month;
    }

    const dispatch = createEventDispatcher();

    // Function to convert month number to month name (for better UI)
    function monthName(month) {
        const monthNames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
        return monthNames[month];
    }

    // Determine the current month
    const currentMonth = new Date().getMonth();
    const sortedMonths = [];
    for (let i = 0; i < 12; i++) {
        sortedMonths.push((currentMonth + i) % 12);
    }
</script>


<OffersListHeader bind:credits/>

{#each sortedMonths as month}
    <div class="month">
        <div class="header">
            <span class="large">{monthName(month)}</span>
            <Credits bind:dealSettings bind:credits bind:month />
        </div>
        
        {#if offers_by_month[month] && offers_by_month[month].length > 0}
            <div class="offers">
                {#each offers_by_month[month] as offer (offer.id)}
                    <OfferItem bind:offer={offer} on:remove={(e) => dispatch("remove", e.detail)} on:toggle={(e) => dispatch("toggle", e.detail)} on:edit={(e) => dispatch("edit", e.detail)}/>
                {/each}
            </div>
        {:else}
            <span class="empty">Es sind noch keine Angebote angelegt</span>
        {/if}
    </div>
{/each}

<style>
    .month {
        /* border-bottom: 1px solid #ebe6e2; */
        padding: 2rem 0;
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    .header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }
    
    .offers {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    .large {
        font-size: 1.25rem;
        font-weight: bold;
    }

    .empty {
        /* font-size: 0.8rem; */
    }
</style>